import { useQuery } from "@tanstack/react-query";
import {
  ApproveCreatorService,
  IGetApproveCreatorListParams,
} from "../../../../../services/vos/business-tickets/approve-creator.service";

const useBusinessTicketApprovers = (params?: IGetApproveCreatorListParams) => {
  const query = useQuery({
    queryKey: ["business-ticket-approvers", params?.recUserId, params?.depId],
    queryFn: () => ApproveCreatorService.getApproveCreatorList(params),
    enabled: !!params?.recUserId && !!params?.depId,
  });

  return query;
};

export default useBusinessTicketApprovers;
